<template>
  <div>
    <Title title="Administrar rutas"
           subtitle="Activa, edita tus rutas y cambia la patente del camión"/>
    <el-form :inline="true" v-model="filter">
      <el-form-item>
        <el-input v-model="filter.tracing_code"
                  placeholder="SEGUIMIENTO"
                  clearable/>
      </el-form-item>
      <el-form-item>
        <el-select  v-model="filter.distribution_centers_id"
                    placeholder="CT"
                    style="width: 280px"
                    filterable
                    multiple
                    no-match-text="No existen coincidencias"
                    no-data-text="Cargando..."
                    clearable>
          <el-option  v-for="ct in data.cts"
                      :key="ct.id"
                      :label="ct.name"
                      :value="ct.id.toString()"/>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select    v-model="filter.enterprise_id"
                      placeholder="EMPRESA"
                      filterable
                      no-match-text="No existen coincidencias"
                      no-data-text="Cargando..."
                      clearable>
          <el-option  v-for="enterprise in data.enterprises"
                      :key="enterprise.id"
                      :label="enterprise.name"
                      :value="enterprise.id.toString()"/>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select    v-model="filter.region_id"
                      placeholder="REGIÓN"
                      filterable
                      no-data-text="Cargando..."
                      no-match-text="No existen coincidencias"
                      clearable>
          <el-option  v-for="region in data.regions"
                      :key="region.id"
                      :label="region.name"
                      :value="region.id.toString()"/>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button class="default searchBttn"
                   @click="handleSearch">
          <i class="fa fa-search"/>
        </el-button>
      </el-form-item>
      <el-form-item>
        <el-button class="flat searchBttnC"
                   @click="cleanFilter">
          <i class="fas fa-broom"></i>&nbsp;&nbsp;LIMPIAR
        </el-button>
      </el-form-item>
    </el-form>
    <el-container class="content">
      <BaseLoadTruck v-show="loadTruck"></BaseLoadTruck>
      <el-table :data="listRoutes" size="mini" class="tableRoutes"
                height="450px" width="90%" fit style="z-index: 1;"
                tooltip-effect="dark">
        <el-table-column  type="expand"
                          min-width="40">
          <template slot-scope="props"
                    style="padding-left: 0">
            <div style="display: inline-flex">
              <div style="display: grid; width: 100px;">
                <p style="color: #a5a5a5; margin-left: 5px;">ESTADO</p>
                <p v-show="props.row.finalized && props.row.active"
                   style="color: #a5a5a5">FINALIZADO</p>
                <p v-show="!props.row.active" style="color: #E6A23C; margin-left: 5px;">
                  PLANIFICADO
                </p>
                <p v-show="props.row.active && !props.row.finalized"
                   style="color: #AAD500">EN RUTA</p>
              </div>
              <div style="display: grid; margin-left: 70px; width: 280px">
                <p style="color: #a5a5a5">CT</p>
                <p style="color: #a5a5a5">{{ props.row.distributioncentername }}</p>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column  label="SEG"
                          align="left"
                          min-width="80"
                          prop="planningstatusesid">
        </el-table-column>
        <el-table-column  label="RUTA"
                          align="left"
                          show-overflow-tooltip
                          min-width="70"
                          prop="id">
          <template slot-scope="scope">
            <p style="white-space: nowrap; overflow:hidden;
                    direction: rtl !important;
                    text-overflow: ellipsis;">
              {{ scope.row.id }}</p>
          </template>
        </el-table-column>
        <el-table-column  label="SOC"
                          min-width="80"
                          align="left"
                          prop="totalsocs"/>
        <el-table-column  label="TRANSPORTE"
                          align="left"
                          show-overflow-tooltip
                          min-width="180"
                          prop="enterprisename">
          <template slot-scope="scope"
                    align="center">
            {{ scope.row.enterprisename.replace('TRANSPORTE' || 'TRANSPORTES', 'T.') }}
          </template>
        </el-table-column>
        <el-table-column  label="FECHA RUTA"
                          align="left"
                          min-width="110"
                          prop="starttime">
          <template slot-scope="scope"
                    align="center">
                    {{ formatDate(scope.row.starttime) }}
          </template>
        </el-table-column>
        <el-table-column  label="ESTIMADO"
                          min-width="110"
                          align="left">
          <template slot-scope="scope"
                    align="center">
              {{ estimateTimeFormat(scope.row.starttime, scope.row.estimatedfinishtime) }}
          </template>
        </el-table-column>
        <el-table-column  label="ORDEN"
                          min-width="110"
                          align="left">
        <template slot-scope="scope"
                  align="center">
                  <div v-if="scope.row.p2p">P2P</div>
                  <div v-else>LIBERADA</div>
        </template>
        </el-table-column>
        <el-table-column label="CONDUCTOR"
                         prop="drivername"
                         show-overflow-tooltip
                         align="left"
                         min-width="180"
                         fixed="right">
          <template slot-scope="scope">
            <el-button v-if="scope.row.driver.id !== 0"
                       style="background-color: transparent !important;
                         border: transparent !important;"
                       type="text"
                       class="button-test"
                       plain
             :icon="scope.row.driver.loading ? 'fas fa-spinner fa-pulse': 'far fa-times-circle'"
                        @click="unlink(scope.row)">
            </el-button>
            <span>{{scope.row.driver.name | decode }}</span>
          </template>
        </el-table-column>
        <el-table-column label="PATENTE"
                         prop="vehiclepatent"
                         align="left"
                         min-width="150"
                         fixed="right">
        </el-table-column>
        <el-table-column label="EDITAR"
                         fixed="right"
                         align="center"
                         min-width="100"
                         prop="id">
          <template slot="header"><span>EDITAR</span>
            <el-tooltip placement="top">
              <div slot="content">
                <p>Presiona el<i class="el-icon-edit" style="color: #AAD500;
                     margin-right: 5px; margin-left: 5px; font-size: 18px;">
                  </i><br>para editar tu ruta.</p><p>
                </p>
              </div>
              <el-button style="margin-left: 5px" type="text"><i class="el-icon-info"></i>
              </el-button>
            </el-tooltip>
          </template>
<!-- EDITAR RUTA (VISTO) -->
          <template slot-scope="scope"
                    align="center">
            <el-button v-if="scope.row.active"
                       type="text"
                       icon="el-icon-edit"
                       style="background-color: transparent !important; border: transparent"
                       plain
                       disabled
                       class="rowIcon">
            </el-button>
            <el-button v-else
                       type="text"
                       icon="el-icon-edit" class="rowIcon"
                       @click="editRoute(scope.row.planningstatusesid)">
            </el-button>
            <el-popover v-if="scope.row.modified" placement="top-start"
                        title="Ruta Modificada" width="100" trigger="click">
                        {{formatDateH(scope.row.modifiedat)}}
              <el-button slot="reference"
                         type="text"
                         icon="el-icon-check"
                         style="font-size: 12px; margin-left: -10px; color: #F5A623">
              </el-button>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
      <el-row>
        <el-col :span="22" :offset="1" class="toolbar">
          <el-pagination layout="total, prev, pager, next"
                         @current-change="handleCurrentChange"
                         :page-size="100"
                         :pager-count="5"
                         :total="totalSize"
                         style="float:right;">
          </el-pagination>
        </el-col>
      </el-row>
    </el-container>
  </div>
</template>
<script>

import moment from 'moment';
import { apiRequest } from '../../backend/vue-axios/axios';
import Title from '../components/base/Title.vue';
import BaseLoadTruck from '../components/BaseLoadTruck.vue';
import { decodeRSA } from '../../mixins/function';
import { cachedAPIRequest } from '../../mixins/cacheDim';
import { getRumDuration, startRumTiming, trackBusinessFlow } from '@/observability/datadogRum';

export default {
  props: ['tracing_code'],
  components: {
    Title,
    BaseLoadTruck,
  },
  data() {
    return {
      data: {
        enterprises: [],
        regions: [],
        cts: [],
      },
      filter: {
        limit: 100,
        enterprise_id: '',
        region_id: '',
        distribution_centers_id: [],
        tracing_code: '',
      },
      editing: null,
      listRoutes: [],
      filtersLoading: false,
      loadTruck: false,
      totalSize: 0,
      activateLoad: false,
      replanningLoad: false,
      dialogTableVisible: false,
    };
  },
  computed: {
    isEditing() {
      return this.editing !== null;
    },
  },
  filters: {
    decode(data) {
      return decodeRSA(data).toUpperCase();
    },
  },
  methods: {
    unlink(row) {
      this.$confirm(`¿Quieres desligar a ${decodeRSA(row.driver.name).split(' ')[0]} de la ruta ${row.id}?`, 'Confirmación', {
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        type: 'warning',
      }).then(() => {
        // eslint-disable-next-line no-param-reassign
        row.driver = {
          id: row.driver.id,
          rut: row.driver.rut,
          name: row.driver.name,
          loading: true,
        };
        apiRequest(
          {
            module: 'planning',
            service: 'unlink_driver',
            pathparam: {
              id: row.id,
            },
          },
        ).then(() => {
          this.$notify({
            type: 'success',
            title: 'Chofer desasociado',
            message: `${decodeRSA(row.driver.name).split(' ')[0]} desasociado de ruta ${row.id}`,
          });
          // eslint-disable-next-line no-param-reassign
          row.driver = {
            id: 0,
            name: '',
            rut: '',
            loading: false,
          };
        }).catch(() => {
          this.$notify.error({
            title: 'Error',
            message: `Error al desasociar a ${decodeRSA(row.driver.name).split(' ')[0]}`,
          });
          // eslint-disable-next-line no-param-reassign
          row.driver.loading = false;
        });
      });
      // eslint-disable-next-line no-param-reassign
    },
    getStatus(parameters = {}) {
      this.loadTruck = true;
      apiRequest(
        {
          module: 'planning',
          service: 'adm_routes',
          params: parameters,
        },
      ).then((res) => {
        if (res && res.data.length > 0) {
          this.listRoutes = res.data;
          this.listRoutes.forEach((element) => {
            // eslint-disable-next-line
            element["driver"] = {
              name: element.driverfullname,
              rut: element.driverrut,
              id: element.driverid,
              loading: false,
            };
          });
        } else {
          this.listRoutes = [];
        }
        this.loadTruck = false;
        this.totalSize = parseInt(res.headers['x-total-count'], 10);
      }).catch(() => {
        this.listRoutes = [];
        this.loadTruck = false;
        this.$notify({
          type: 'error',
          title: 'Error',
          message: 'Problemas al cargar las Rutas',
        });
      });
    },
    handleCurrentChange(newPage) {
      this.loadTruck = true;
      this.getStatus({
        limit: this.filter.limit,
        enterprise_id: this.filter.enterprise_id,
        region_id: this.filter.region_id,
        distribution_centers_id: this.filter.distribution_centers_id,
        tracing_code: this.filter.tracing_code,
        offset: this.getLimitPage(newPage),
      });
    },
    getLimitPage(page) {
      return ((page - 1) * 100);
    },
    cleanFilter() {
      this.$router.replace({ query: null });
      this.filter.enterprise_id = '';
      this.filter.region_id = '';
      this.filter.distribution_centers_id = [];
      this.filter.tracing_code = '';
    },
    handleSearch() {
      this.loadTruck = true;
      this.$router.replace({ query: null });
      this.getStatus(this.filter);
      this.$router.push({
        name: 'modify',
        query: {
          region_id: this.filter.region_id,
          tracing_code: this.filter.tracing_code,
          enterprise_id: this.filter.enterprise_id,
          distribution_centers_id: this.filter.distribution_centers_id,
        },
      });
    },
    reLoad() {
      this.getStatus();
    },
    filterStatus(value, row) {
      return row.modified === value;
    },
    getDistributionCenters() {
      cachedAPIRequest({
        module: 'planning',
        service: 'distribution_centers',
        params: { limit: 1000 },
      }).then((data) => {
        this.data.cts = data.data;
        if (this.$route.query.distribution_centers_id != null) {
          const distributionCenters = this.$route.query.distribution_centers_id
            .filter(qdc => data.data.reduce((acc, ddc) => acc || ddc.id.toString() === qdc, false));
          this.filter.distribution_centers_id = distributionCenters;
          if (this.$route.query.distribution_centers_id.length > distributionCenters.length) {
            this.getStatus(this.filter);
          }
        }
      }).catch(() => {
        this.$notify.error({
          title: 'Error',
          message: 'No se pudo cargar los CT',
        });
      });
    },
    getEnterprises() {
      cachedAPIRequest({
        module: 'planning',
        service: 'enterprises',
        params: {
          limit: 6000,
        },
      }).then((data) => {
        this.data.enterprises = data.data;
        if (this.$route.query.enterprise_id != null) {
          const enterprise = this.data.enterprises
            .filter(item => item.id.toString() === this.$route.query.enterprise_id);
          if (enterprise.length === 0) {
            this.filter.enterprise_id = '';
            this.getStatus(this.filter);
          }
        }
      }).catch(() => {
        this.$notify.error({
          title: 'Error',
          message: 'Error al cargar empresas',
        });
      });
    },
    getRegions() {
      cachedAPIRequest({
        module: 'planning',
        service: 'regions',
        params: { limit: 1000 },
      }).then((data) => {
        this.data.regions = data.data;
        if (this.$route.query.region_id != null) {
          const region = this.data.regions
            .filter(item => item.id.toString() === this.$route.query.region_id);
          if (region.length === 0) {
            this.filter.region_id = '';
            this.getStatus(this.filter);
          }
        }
      }).catch(() => {
        this.$notify.error({
          title: 'Error',
          message: 'Error al cargar las regiones',
        });
      });
    },
    formatDate(date) {
      return moment.utc(date).format('DD-MM-YYYY');
    },
    formatDateH(date) {
      return moment(date).format('DD-MM-YYYY - LT');
    },
    estimateTimeFormat(dateStart, dateEstimate) {
      const hours = moment(dateEstimate).diff(dateStart, 'hours');
      let minutes = moment(dateEstimate).diff(dateStart, 'minutes');
      minutes -= (hours * 60);
      const fMinutes = `00${minutes.toString()}`.substr((`00${minutes}`).length - 2, 2);
      const fHours = hours.toString();
      return `${fHours}:${fMinutes} hrs`;
    },
    truncateDecimal(number) {
      const t = number.toString();
      const regex = /(\d*.\d{0,2})/;
      return t.match(regex)[0];
    },
    /*
    getIdTrl(idRoute) {
      const notifyIdTrl = this.$message({
        message: `Obteniendo id TRL Ruta: ${idRoute}, espera un momento por favor`,
        duration: 0,
        showClose: true,
      });
      apiRequest({
        module: 'planning',
        service: 'trl_id',
        pathparam: { id: idRoute },
        params: { id: idRoute },
      }).then((data) => {
        this.$notify({
          type: 'success',
          title: 'Id TRL',
          message: data.response.data.message,
        });
        notifyIdTrl.close();
      }).catch((error) => {
        // TODO: Mensajes respuesta TRL
        if (error.response.data.message.indexOf('nested') === 0){
          this.$notify.error({
            title: 'Error',
            message: 'Error inesperado',
          });
        } else {
          this.$notify.error({
            title: 'Error',
            message: error.response.data.message,
          });
        }
        notifyIdTrl.close();
      });
    },
   */
    editRoute(rowId) {
      trackBusinessFlow({
        module: 'planning',
        flow: 'route_editing',
        action: 'edit_view_opened',
        status: 'success',
        context: {
          tracing_id: rowId,
          source: 'planning_modify',
        },
      });
      const parameter = { idTracing: `${rowId}` };
      parameter.v = 4;
      this.$router.push({
        name: 'editMultiple',
        params: parameter,
      });
    },
    onCellBlur() {
      this.editing = null;
    },
    changeActivate(row) {
      if (row.totalsocs !== 0) {
        this.$confirm('¿Quieres activar la ruta?', 'Confirmación', {
          confirmButtonText: 'Si',
          cancelButtonText: 'No',
          type: 'warning',
        }).then(() => {
          const startedAt = startRumTiming();
          trackBusinessFlow({
            module: 'planning',
            flow: 'route_activation',
            action: 'activation_requested',
            status: 'attempt',
            context: {
              route_id: row.id,
              source: 'planning_modify',
            },
          });
          this.$message({
            message: `Activando Ruta ${row.id}, espera un momento por favor`,
            duration: 10000,
            showClose: true,
          });
          apiRequest({
            module: 'planning',
            service: 'activate_route',
            pathparam: { id: row.id },
            params: { id: row.id },
          }).then((res) => {
            this.$notify({
              type: 'success',
              title: 'ACTIVACIÓN REALIZADA',
              message: `Ruta Nº ${res.data.id} activada`, // TODO No envia mensaje al activar la ruta.
            });
            trackBusinessFlow({
              module: 'planning',
              flow: 'route_activation',
              action: 'activation_completed',
              status: 'success',
              durationMs: getRumDuration(startedAt),
              context: {
                route_id: row.id,
                source: 'planning_modify',
              },
            });
            const routeSelected = this.listRoutes.filter(route => route.id === row.id);
            routeSelected[0].active = true;
          }).catch((error) => {
            trackBusinessFlow({
              module: 'planning',
              flow: 'route_activation',
              action: 'activation_completed',
              status: 'error',
              durationMs: getRumDuration(startedAt),
              context: {
                route_id: row.id,
                source: 'planning_modify',
                error_status: error.response ? error.response.status : null,
              },
            });
            if (error.response) {
              this.$notify({
                type: 'error',
                title: 'Error',
                message: error.response.data.message, // TODO ¿Cuales son los otros mensajes?
              });
            }
            const routeSelected = this.listRoutes.filter(route => route.id === row.id);
            routeSelected[0].active = false;
          });
        }).catch(() => {
          trackBusinessFlow({
            module: 'planning',
            flow: 'route_activation',
            action: 'activation_cancelled',
            status: 'cancelled',
            context: {
              route_id: row.id,
              source: 'planning_modify',
            },
          });
          const routeSelected = this.listRoutes.filter(route => route.id === row.id);
          routeSelected[0].active = false;
        });
      } else {
        trackBusinessFlow({
          module: 'planning',
          flow: 'route_activation',
          action: 'activation_blocked',
          status: 'blocked',
          context: {
            route_id: row.id,
            source: 'planning_modify',
            reason: 'empty_route',
          },
        });
        this.$message({
          type: 'warning',
          title: 'ADVERTENCIA',
          message: 'No se puede activar una ruta con 0 soc',
        });
      }
    },
    changeReplanning(row) {
      this.$confirm('¿Quieres replanificar la ruta?', 'Confirmación', {
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        type: 'warning',
      }).then(() => {
        const startedAt = startRumTiming();
        trackBusinessFlow({
          module: 'planning',
          flow: 'route_replanning',
          action: 'replanning_requested',
          status: 'attempt',
          context: {
            route_id: row.id,
            source: 'planning_modify',
          },
        });
        this.$message({
          message: `Replanificando Ruta ${row.id}, espera un momento por favor`,
          duration: 10000,
          showClose: true,
        });
        apiRequest({
          module: 'planning',
          service: 'replanning_route',
          pathparam: { id: row.id },
          params: { id: row.id },
        }).then((res) => {
          this.replanningLoad = false;
          this.$notify({
            type: 'success',
            title: 'REPLANIFICACIÓN ACEPTADA',
            message: `Ruta Nº ${res.data.id} en espera...`, // TODO No envia mensaje al activar la ruta.
          });
          trackBusinessFlow({
            module: 'planning',
            flow: 'route_replanning',
            action: 'replanning_completed',
            status: 'success',
            durationMs: getRumDuration(startedAt),
            context: {
              route_id: row.id,
              source: 'planning_modify',
            },
          });
          const routeSelected = this.listRoutes.filter(route => route.id === row.id);
          routeSelected[0].replanning_state = 1;
          // routeSelected[0].modified = false;
        }).catch((error) => {
          trackBusinessFlow({
            module: 'planning',
            flow: 'route_replanning',
            action: 'replanning_completed',
            status: 'error',
            durationMs: getRumDuration(startedAt),
            context: {
              route_id: row.id,
              source: 'planning_modify',
              error_status: error.response ? error.response.status : null,
            },
          });
          if (error.response.status > 400 && error.response.status < 500) {
            this.$notify({
              type: 'warning',
              title: 'Planificación en proceso',
              showClose: true,
              message: error.response.data.message,
            });
          } else {
            this.$notify({
              type: 'error',
              title: 'Error',
              showClose: true,
              message: error.response.data.message,
            });
          }
          const routeSelected = this.listRoutes.filter(route => route.id === row.id);
          routeSelected[0].modified = true;
        });
      }).catch(() => {
        trackBusinessFlow({
          module: 'planning',
          flow: 'route_replanning',
          action: 'replanning_cancelled',
          status: 'cancelled',
          context: {
            route_id: row.id,
            source: 'planning_modify',
          },
        });
        const routeSelected = this.listRoutes.filter(route => route.id === row.id);
        routeSelected[0].modified = true;
      });
    },
    thousandsSeparator(num) {
      const str = num.toString();
      let returnValue = '';
      let countIndex = 0;
      for (let i = str.length - 1; i > -1; i -= 1) {
        if (countIndex === 2 && i !== 0) {
          returnValue = `.${str.charAt(i)}${returnValue}`;
          countIndex = 0;
        } else {
          returnValue = str.charAt(i) + returnValue;
          countIndex += 1;
        }
      }
      return returnValue;
    },
  },
  created() {
    this.loadTruck = true;
    this.filter.region_id = this.$route.query.region_id;
    this.filter.tracing_code = this.$route.query.tracing_code;
    this.filter.enterprise_id = this.$route.query.enterprise_id;
    this.filter.distribution_centers_id = this.$route.query.distribution_centers_id;
    this.getStatus(this.filter);
    this.getRegions();
    this.getEnterprises();
    this.getDistributionCenters();
  },
};
</script>
<style lang="scss" scoped>
  .el-form {
    display: flex;
  }
  .el-form-item {
    position: relative;
  }
  .el-input__inner{
    height: 40px !important;
  }
  .content {
    text-align: left;
    display: grid;
  }
  .searchBttn {
    margin-top: 1px;
    height: 40px;
    width: 60px;
  }
  .rowIcon{
    font-size: 20px;
    color: #AAD500;
    font-weight: 600;
    outline: none;
  }
  .titleStyle {
    font-size: 12px;
    color: #AAD500;
    font-weight: 900;
    text-transform: uppercase;
    margin: 0;
  }
  .elementStyle {
    font-size: 14px;
    color: #707070;
    font-weight: 300;
    margin: 0 0 1em;
    &:last-of-type {
      margin: 0;
    }
  }
  .el-icon-truck {
    margin-right: 10px;
    font-size: 24px;
    color: #c0c4cc;
    display: table-cell;
    vertical-align: middle;
  }
  .button-test:hover {
    cursor: pointer;
  }
  .spCla {
    font-size: 12px;
    color: #707070;
    vertical-align: middle;
    margin-left: 5px;
  }
  .searchBttnC {
    margin-top: 1px;
    height: 40px;
    width: 120px;
  }
  @media only screen and (min-height: 900px) {
    .el-table {
      height: 600px !important;
    }
  }

  .rotate-1 {
    webkit-animation: rotating 5s linear infinite;
    animation: rotating 5s linear infinite;
  }

  .el-icon-refresh-right {
    padding: 3px;
    color: white;
    border-radius: 50%;
    background-color: #09558f;
  }
</style>
